<ng-container *ngIf="dialog$ | async as dialog">
	<app-ui-dialog
		[visible]="true"
		[title]="dialog.title"
		[primaryLabel]="dialog.primaryLabel"
		[secondaryLabel]="dialog.secondaryLabel"
		[showCloseButton]="dialog.showCloseButton"
		[dismissableMask]="dialog.dismissableMask"
		[closeOnEscape]="dialog.closeOnEscape"
		(primaryAction)="onAccept()"
		(secondaryAction)="onReject()"
		(closeAction)="onDismiss()"
	>
		<p class="ui-dialog-host__message" data-test="ui-dialog-message">
			{{ dialog.message | translate }}
		</p>
	</app-ui-dialog>
</ng-container>
